import { useMemo } from 'react';
import type { CalculationMode } from '@/lib/portfolioCalculations';

export function useEffectiveAllocations(
  baseAllocations: any[],
  overrides: Record<string, number>,
  calcMode: CalculationMode,
  portfolioSize: number
) {
  return useMemo(() => {
    const mapped = (baseAllocations || []).map((a: any) => {
      const ov = overrides[a?.id as string];
      if (ov === undefined) return a;
      if (calcMode === 'percentage') {
        return { ...a, allocation_percentage: ov };
      }
      const val = Math.round(((ov / 100) * portfolioSize) * 100) / 100;
      return { ...a, allocation_percentage: ov, allocation_value: val, is_value_locked: true };
    });

    if (mapped.length === 0 && Object.keys(overrides || {}).length > 0) {
      return Object.entries(overrides).map(([id, pct]) => {
        const safePct = Number(pct) || 0;
        if (calcMode === 'percentage') {
          return { id, allocation_percentage: safePct } as any;
        }
        const val = Math.round(((safePct / 100) * portfolioSize) * 100) / 100;
        return { id, allocation_percentage: safePct, allocation_value: val, is_value_locked: true } as any;
      });
    }

    return mapped;
  }, [baseAllocations, overrides, calcMode, portfolioSize]);
}
